import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContablePENFormGroup = ({ iError, iTouched, iReadonlyInfo, setFieldValue }) => {
  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContablePEN', '')
    setFieldValue('nombreCuentaContablePEN', '')
  }, [setFieldValue])

  const onChangeCuenta = React.useCallback(
    sel => {
      setFieldValue('cuentaContablePEN', sel.value)
      setFieldValue('nombreCuentaContablePEN', sel.label)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='CUENTA PEN' htmlFor='input-cuentaContablePEN' md={4} alignRightAt='md' />
      <Col md={8}>
        {iReadonlyInfo ? (
          <ClearInputGroup id='readonly-cuentaContablePEN' iValue={iReadonlyInfo} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable onlyAnalitica onChange={onChangeCuenta} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContablePENFormGroup)
